import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fe9b5d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auto-switch-tab-list" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "no" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "no-img"
}
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "value" }

import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import type { Tab } from '../types' // Assuming you have a types file for the Tab interface
// [
//                 {
//                   label: '储能充电',
//                   list: [
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                   ],
//                 },
//                 {
//                   label: '储能放电',
//                   list: [
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                   ],
//                 },
//                 {
//                   label: '光伏发电',
//                   list: [
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                     { name: 'zhandianA', value: 82 },
//                   ],
//                 },
//               ]


export default /*#__PURE__*/_defineComponent({
  props: {
    tabs: null,
    switchInterval: null
  },
  setup(__props: any) {

const props = __props as {
  tabs: Tab[]
  switchInterval?: number // ms
}



const activeTab = ref('0')
let timer: number | undefined

const currentList = computed(() => {
  const idx = Number(activeTab.value)
  return props.tabs[idx]?.list || []
})

const startAutoSwitch = () => {
  clearInterval(timer)
  timer = window.setInterval(() => {
    const idx = Number(activeTab.value)
    const next = (idx + 1) % props.tabs.length
    activeTab.value = String(next)
  }, props.switchInterval || 3000)
}

watch(() => props.switchInterval, startAutoSwitch)
watch(() => props.tabs, startAutoSwitch)

onMounted(startAutoSwitch)
onBeforeUnmount(() => clearInterval(timer))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.label,
          class: _normalizeClass(["tab", Number(activeTab.value) === idx ? 'active' : ''])
        }, _toDisplayString(tab.label), 3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentList), (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: item.id || idx
        }, [
          _createElementVNode("span", _hoisted_4, [
            (idx <= 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require(`@/assets/datav/No${idx + 1}.svg`),
                  alt: ""
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "No." + _toDisplayString(idx + 1), 1))
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(Number(item.value).toFixed(0) || 0) + " kW", 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})